import React, { useState } from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip';
import { ItemValueType, SummationType } from '../../../../Models/PerformanceItem';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { currencyFormatter } from '../../../../Helpers/Utilities';
import { Input, InputChangeEvent } from '@progress/kendo-react-inputs';
import { styled } from '@mui/material/styles';
import { IconButton } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import { httpGetAsync } from '../../../../Http/HttpClient';
import { authService } from '../../../..';
import { useSelector } from 'react-redux';
import { AppState } from '../../../../Store/rootReducer';
import { PerformanceItemNote } from '../../../../Models/PerformanceItemNote';
import { useDialog } from '../../../Providers/DialogProvider';
import MessageDialog from '../../../Dialogs/MessageDialog/MessageDialog';
import { F, isNotNil } from 'ramda';
import { IPerformanceReportItemValue } from '../../../../Models/PerformanceReportItemValue';


export const ChangeCell = (props: GridCellProps) => {
  return (
    <td style={{ cursor: `pointer`, pointerEvents: `all`, paddingLeft: '12px', paddingTop: '1​2px', paddingBottom: '0px', paddingRight: '0px' }}>
      {props.dataItem!.change > 0 && (
        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
          <div style={{ color: 'green', width: '90px', display: 'flex', justifyContent: 'flex-end', marginRight: '5px' }}>{props.dataItem!.change.toFixed(2)}%</div><ArrowUpwardIcon style={{ color: 'green' }} />
        </div>
      )}
      {props.dataItem!.change < 0 && (
        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
          <div style={{ color: 'red', width: '80px', display: 'flex', justifyContent: 'flex-end', marginRight: '5px' }}>({props.dataItem!.change.toFixed(2)}%)</div><ArrowDownwardIcon style={{ color: 'red' }} />
        </div>
      )}
      {props.dataItem!.change === 0 && (
        <div></div>
      )}
    </td>
  );
};
export const SortOrderCell = (props: GridCellProps) => {
  return (
    <td>
      <span>{
        props.dataItem!.sortOrder
      }
      </span>
    </td>
  )
}
export const MoneyCell = (props: GridCellProps) => {
  return (
    <td>
      <span>{
        props.dataItem!.sourceValue === 0
          ? ''
          : props.dataItem!.sourceValue && props.dataItem.valueType === ItemValueType.Dollars
            ? `${currencyFormatter.format(props.dataItem!.sourceValue)}`
            : props.dataItem.valueType === ItemValueType.Percent
              ? `${props.dataItem!.sourceValue.toFixed(2)}`
              : props.dataItem.valueType === ItemValueType.Text
                ? props.dataItem!.sourceValue
                : props.dataItem!.sourceValue?.toFixed(0)}
      </span>
    </td>
  )
}

export const NameCell = (props: GridCellProps) => {
  const description = props.dataItem!.description;
  const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#25b558',
      color: 'white',
      boxShadow: theme.shadows[1],
      fontSize: 14,
    },
  }));
  return (
    <td>
      <LightTooltip title={description} aria-label='Item Description' arrow placement='right-start' style={{ background: 'red' }}>
        <span style={{ alignItems: 'center' }}>
          <span style={{ cursor: 'help', marginRight: '5px' }}>{props.dataItem!.name}</span>
          {props.dataItem.summationType === SummationType.Subtract ? <span style={{ color: 'red' }}>(-)</span>
            : props.dataItem.summationType === SummationType.Add ? <span style={{ color: 'green' }}>(+)</span>
              : <span style={{ color: 'black' }}></span>}
        </span>
      </LightTooltip>
    </td>
  )
}
export const SummaryMoneyCellCurrent = (props: GridCellProps) => {
  return (
    <td>
      <span>{props.dataItem!.thisReport && props.dataItem.valueType === ItemValueType.Dollars
        ? currencyFormatter.format(props.dataItem!.thisReport) // Remove Number() wrapper
        : !props.dataItem!.thisReport || props.dataItem!.thisReport === ''
          ? '0'
          : parseFloat(props.dataItem!.thisReport).toFixed(2)}
      </span>
    </td>
  )
}

export const SummaryMoneyCellPrevious = (props: GridCellProps) => {
  return (
    <td>
      <span>{props.dataItem!.lastReport && props.dataItem.valueType === ItemValueType.Dollars
        ? `${currencyFormatter.format(Number(props.dataItem!.lastReport.toFixed(2)))}`
        : !props.dataItem!.lastReport || props.dataItem!.lastReport === ''
          ? 0
          : Number(props.dataItem!.lastReport).toFixed(2)}
      </span>
    </td>
  )
}
export const SummaryMoneyCellPreviousPeriod = (props: GridCellProps) => {
  return (
    <td>
      <span>{props.dataItem!.previousPeriodValue && props.dataItem.valueType === ItemValueType.Dollars
        ? `${currencyFormatter.format(props.dataItem!.previousPeriodValue.toFixed(0))}`
        : props.dataItem!.previousPeriodValue}
      </span>
    </td>
  )
}
export const NotesCell = (props: GridCellProps) => {
  const reportClientId = useSelector((state: AppState) => state.performanceReport.performanceReport!.clientId);
  // const [value, setValue] = useState(props.dataItem.notes);
  const [openDialog, closeDialog] = useDialog();
  const changeHandler = (event: InputChangeEvent) => {
    props.onChange && props.onChange({
      dataIndex: 0,
      dataItem: props.dataItem,
      field: props.field,
      syntheticEvent: event.syntheticEvent,
      value: event.target.value
    });
  }
  return (
    <td>
      <div style={{display: 'flex', alignItems: 'center'}}>
        <Input
          valid={true}
          type={"text"}
          value={props.dataItem.notes}
          readOnly={!props.dataItem.inEdit}
          onChange={(event: InputChangeEvent) => {
            // setValue(event.value);
            changeHandler(event);
          }}
        />
        <Tooltip title="Click to get a list of all notes for this item from previous reporting periods">
          <IconButton
            onClick={async () => {
              const token: string = await authService.getToken();
              const response = await httpGetAsync(
          `${authService.appSettings.GetWebApiBaseUri()}/PerformanceReport/performanceItemNotes/${props.dataItem.performanceItemId}/${reportClientId}`, token);

              if (response && response.ok) {
          const notes: PerformanceItemNote[] = await response.json();
          
          openDialog({
            fullScreen: false,
            children: (
              <MessageDialog
                style={{width: '500px', maxWidth: '500px', maxHeight: '100vh'}}
                contentStyle={{maxHeight: '300px', overflowY: 'auto'}}
                title={'Performance Item Notes'}
                closeDialog={closeDialog}   
                accept={() => closeDialog()}                 
                message={<div>
            {notes.length > 0 && notes.map((note: PerformanceItemNote, index: number) => {
              return (
                <div key={index}>                            
                  <div style={{fontWeight: 'bold'}}>{note.reportYear}/{note.reportMonth}</div>
                  <div>{note.notes}</div>
                </div>
              );
            })}
            {notes.length === 0 && <div>No notes found.</div>}
                </div>}
              />
            ),
          });
              }
            }}
          >
            <HistoryIcon fontSize='small' color='info' />
          </IconButton>
        </Tooltip>
      </div>
    </td>
  );
}